/* Chezvia "How to Measure" block for the Size Guide popup.
   Pattern copied from Spark Paws: a simple pet silhouette with a dashed line on the spot to measure,
   one short sentence per measurement. Only the measurements used by that product's chart are shown,
   plus a "no measuring tape" tip (string + ruler).
   Methods follow AKC (neck, chest, back, two-finger rule), PetMD (string, weighing at home),
   Ruffwear (paw on paper with weight on it) and Pet Parents (waist in front of the back legs). */
(function () {
  var C = '#C26B4A', F = '#D3CABC', D = '#B9AE9D', INK = '#253238';

  var DOG = '<path d="M64 98C42 90 34 66 42 46" fill="none" stroke="' + F + '" stroke-width="10" stroke-linecap="round"/>' +
    '<g fill="' + F + '"><ellipse cx="136" cy="112" rx="78" ry="30"/><ellipse cx="196" cy="110" rx="30" ry="33"/>' +
    '<path d="M188 96L222 46L252 58L224 112Z"/><ellipse cx="244" cy="56" rx="24" ry="20"/><rect x="250" y="52" width="36" height="20" rx="10"/>' +
    '<path d="M74 120h15v62a7 7 0 0 1-7 7h-4a6 6 0 0 1-6-6z"/><path d="M96 122h15v60a7 7 0 0 1-7 7h-4a6 6 0 0 1-6-6z"/>' +
    '<path d="M180 124h15v58a7 7 0 0 1-7 7h-4a6 6 0 0 1-6-6z"/><path d="M202 122h15v60a7 7 0 0 1-7 7h-4a6 6 0 0 1-6-6z"/>' +
    '<ellipse cx="80" cy="188" rx="10" ry="5"/><ellipse cx="102" cy="188" rx="10" ry="5"/><ellipse cx="186" cy="188" rx="10" ry="5"/><ellipse cx="208" cy="188" rx="10" ry="5"/></g>' +
    '<ellipse cx="236" cy="56" rx="9" ry="19" transform="rotate(22 236 56)" fill="' + D + '"/><circle cx="252" cy="50" r="3" fill="' + INK + '"/><circle cx="285" cy="60" r="4.5" fill="' + INK + '"/>';

  var CAT = '<path d="M68 106C36 100 28 72 46 54" fill="none" stroke="' + F + '" stroke-width="9" stroke-linecap="round"/>' +
    '<g fill="' + F + '"><ellipse cx="140" cy="118" rx="74" ry="27"/><ellipse cx="196" cy="114" rx="26" ry="29"/>' +
    '<path d="M192 100L218 62L244 72L222 116Z"/><ellipse cx="238" cy="72" rx="24" ry="21"/><path d="M220 60L224 32L240 54Z"/><path d="M240 54L256 30L260 62Z"/>' +
    '<rect x="84" y="124" width="13" height="62" rx="6"/><rect x="104" y="126" width="13" height="60" rx="6"/><rect x="184" y="126" width="13" height="60" rx="6"/><rect x="204" y="124" width="13" height="62" rx="6"/>' +
    '<ellipse cx="90" cy="188" rx="9" ry="4.5"/><ellipse cx="110" cy="188" rx="9" ry="4.5"/><ellipse cx="190" cy="188" rx="9" ry="4.5"/><ellipse cx="210" cy="188" rx="9" ry="4.5"/></g>' +
    '<circle cx="246" cy="68" r="3" fill="' + INK + '"/><circle cx="260" cy="78" r="3" fill="' + INK + '"/>';

  function dash(d) { return '<path d="' + d + '" fill="none" stroke="' + C + '" stroke-width="4.5" stroke-dasharray="8 5" stroke-linecap="round"/>'; }
  function ring(cx, cy, rx, ry, rot) { return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '"' + (rot ? ' transform="rotate(' + rot + ' ' + cx + ' ' + cy + ')"' : '') + ' fill="none" stroke="' + C + '" stroke-width="4.5" stroke-dasharray="8 5"/>'; }
  function svg(inner) { return '<svg viewBox="0 0 300 200" role="img" aria-hidden="true" focusable="false">' + inner + '</svg>'; }

  var ART = {
    dog: {
      neck: DOG + ring(213, 88, 7, 23, -32),
      chest: DOG + ring(178, 112, 9, 35),
      back: DOG + dash('M68 72H208') + '<path d="M68 62v20M208 62v20" stroke="' + C + '" stroke-width="4.5" stroke-linecap="round"/>',
      waist: DOG + ring(124, 112, 8, 29),
      belly: DOG + ring(136, 112, 8, 30)
    },
    cat: {
      neck: CAT + ring(212, 94, 6, 20, -32),
      chest: CAT + ring(180, 116, 8, 31),
      back: CAT + dash('M72 84H206') + '<path d="M72 74v20M206 74v20" stroke="' + C + '" stroke-width="4.5" stroke-linecap="round"/>',
      waist: CAT + ring(128, 118, 7, 26),
      belly: CAT + ring(140, 118, 7, 27)
    },
    paw: '<rect x="48" y="12" width="204" height="176" rx="6" fill="#fff" stroke="#E6DFD3" stroke-width="2"/>' +
      '<g fill="' + F + '"><ellipse cx="146" cy="124" rx="38" ry="32"/><ellipse cx="104" cy="80" rx="14" ry="18"/><ellipse cx="132" cy="62" rx="14" ry="19"/><ellipse cx="162" cy="62" rx="14" ry="19"/><ellipse cx="189" cy="80" rx="14" ry="18"/></g>' +
      '<path d="M222 40V158M214 40h16M214 158h16M86 172H206M86 164v16M206 164v16" stroke="' + C + '" stroke-width="4.5" stroke-linecap="round"/>',
    weight: '<rect x="70" y="120" width="160" height="56" rx="12" fill="' + F + '"/><rect x="118" y="134" width="64" height="26" rx="5" fill="#fff"/>' +
      '<path d="M128 147h44" stroke="' + C + '" stroke-width="4.5" stroke-linecap="round"/>' +
      '<path d="M150 112V40M128 62l22-22 22 22" fill="none" stroke="' + D + '" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>',
    string: '<path d="M36 70C70 20 112 112 150 60S226 30 264 74" fill="none" stroke="' + D + '" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M36 128H232" stroke="' + D + '" stroke-width="5" stroke-linecap="round"/><circle cx="232" cy="128" r="7" fill="' + C + '"/>' +
      '<path d="M150 82v24" stroke="' + INK + '" stroke-width="3" stroke-linecap="round"/><path d="M142 98l8 8 8-8" fill="none" stroke="' + INK + '" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<rect x="30" y="142" width="240" height="30" rx="4" fill="#EFE7DB" stroke="' + F + '"/>' +
      (function () { var t = ''; for (var i = 0; i <= 12; i++) t += '<path d="M' + (40 + i * 18.3) + ' 142v' + (i % 2 ? 8 : 14) + '" stroke="#8C8273" stroke-width="2"/>'; return t; })()
  };

  var TEXT = {
    neck: ['Neck', 'Measure where the collar sits, at the base of the neck.'],
    chest: ['Chest', 'Measure around the widest part of the chest, just behind the front legs.'],
    back: ['Back Length', 'Measure along the back, from the base of the neck to the base of the tail.'],
    waist: ['Waist', 'Measure around the belly at the narrowest part, just in front of the back legs.'],
    belly: ['Belly', 'Measure around the middle of the body, halfway between the front and back legs.'],
    paw: ['Paw', 'Put a sheet of paper under a front paw and lift the opposite paw so your dog stands on it. Holding the pen straight up, mark the front, back and both sides, then measure.'],
    weight: ['Weight', 'Weigh yourself holding your pet, then weigh yourself alone. The difference is your pet’s weight. Too heavy to lift safely? Your vet can weigh your pet.']
  };

  var css = '.cz-how{margin:2.4rem 0 0;font-family:inherit;color:' + INK + '}' +
    '.cz-how h3{margin:0 0 .4rem;font-size:1.9rem;line-height:1.2;letter-spacing:-.01em}' +
    '.cz-how__sub{margin:0 0 1.4rem;font-size:1.35rem;line-height:1.5;color:rgba(37,50,56,.72)}' +
    '.cz-how__grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1rem}' +
    '.cz-how__card{background:#fff;border:1px solid #E6DFD3;border-radius:12px;padding:1rem 1rem 1.2rem}' +
    '.cz-how__card svg{display:block;width:100%;height:auto;margin:0 0 .6rem}' +
    '.cz-how__card:last-child:nth-child(odd){grid-column:1/-1;display:grid;grid-template-columns:48% 1fr;gap:1rem;align-items:center}' +
    '.cz-how__card:last-child:nth-child(odd) svg{margin:0}' +
    '.cz-how__card strong{display:block;font-size:1.4rem;margin:0 0 .3rem}' +
    '.cz-how__card p{margin:0;font-size:1.2rem;line-height:1.45;color:rgba(37,50,56,.78)}' +
    '.cz-how__tape{display:grid;grid-template-columns:42% 1fr;gap:1.2rem;align-items:center;margin:1.2rem 0 0;padding:1.2rem;background:#EFE7DB;border-radius:12px}' +
    '.cz-how__tape svg{display:block;width:100%;height:auto}' +
    '.cz-how__tape strong{display:block;font-size:1.45rem;margin:0 0 .5rem}' +
    '.cz-how__tape ol{margin:0;padding-left:1.8rem;font-size:1.25rem;line-height:1.5}' +
    '.cz-how__tape li{margin:0 0 .35rem}' +
    '.cz-how__tips:empty{display:none}.cz-how__tips{margin:1.2rem 0 0;padding:0;list-style:none;font-size:1.25rem;line-height:1.5}' +
    '.cz-how__tips li{position:relative;padding-left:2.2rem;margin:0 0 .4rem}' +
    '.cz-how__tips li:before{content:"\\2713";position:absolute;left:0;color:' + C + ';font-weight:700}' +
    '@media (max-width:420px){.cz-how__tape{grid-template-columns:1fr}.cz-how__tape svg{max-width:240px}}' +
    '.cz-how__jump{display:inline-block;margin:0 0 1.2rem;font-size:1.3rem;font-weight:600;color:' + C + ';text-decoration:underline;text-underline-offset:3px}' +
    '.cz-sg{--cz-blue:#1F4656 !important}.cz-sg .cz-sg__tip{background:#EFE7DB !important}';

  function ensureCss() {
    if (document.getElementById('cz-how-style')) return;
    var s = document.createElement('style'); s.id = 'cz-how-style'; s.textContent = css; document.head.appendChild(s);
  }

  function measuresFor(sg) {
    /* Only columns that describe the pet. Columns about the product itself
       ("Carrier Chest", "Neck Opening", "Bed Dimensions", "Cup Height"...) are skipped. */
    var head = Array.prototype.map.call(sg.querySelectorAll('thead th'), function (th) { return th.textContent.toLowerCase(); })
      .filter(function (t) { return !/carrier|opening|dimension|cup|base|collar width|inner sole/.test(t) || /paw/.test(t); }).join(' | ');
    var list = [];
    if (/neck/.test(head)) list.push('neck');
    if (/chest/.test(head)) list.push('chest');
    if (/back/.test(head)) list.push('back');
    if (/waist/.test(head)) list.push('waist');
    if (/belly/.test(head)) list.push('belly');
    var tip = (sg.querySelector('.cz-sg__tip') || {}).textContent || '';
    var rawHead = ((sg.querySelector('thead') || {}).textContent || '').toLowerCase();
    if (/paw/.test(head) || (/opening/.test(rawHead) && /paw/i.test(tip))) list.push('paw');
    if (/weight/.test(head)) list.push('weight');
    return list;
  }

  /* Silhouette + wording: "Cat" or "Dog" from the short name; "Pet" products use the first animal named in the full title. */
  function petInfo() {
    var h = document.querySelector('.product__title h1');
    var shortName = h ? h.textContent : '';
    var full = (h && h.getAttribute('title')) || shortName || document.title;
    var c = /\bcats?\b/i, d = /\bdogs?\b/i;
    if (c.test(shortName) && !d.test(shortName)) return { art: 'cat', noun: 'cat' };
    if (d.test(shortName)) return { art: 'dog', noun: 'dog' };
    var ci = full.search(c), di = full.search(d);
    return { art: (ci > -1 && (di < 0 || ci < di)) ? 'cat' : 'dog', noun: 'pet' };
  }

  function build(sg) {
    var list = measuresFor(sg);
    if (!list.length) return null;
    var info = petInfo(), pet = info.noun;
    var tipText = ((sg.querySelector('.cz-sg__tip') || {}).textContent || '');
    var tapeable = list.some(function (m) { return m !== 'paw' && m !== 'weight'; });
    var cards = list.map(function (m) {
      var art = (m === 'paw' || m === 'weight') ? ART[m] : ART[info.art][m];
      return '<div class="cz-how__card">' + svg(art) + '<div><strong>' + TEXT[m][0] + '</strong><p>' + TEXT[m][1] + '</p></div></div>';
    }).join('');
    var tape = tapeable ? '<div class="cz-how__tape">' + svg(ART.string) + '<div><strong>No measuring tape? Use a string.</strong><ol>' +
      '<li>Wrap a piece of string, a shoelace or a phone charger cable around your ' + pet + '.</li>' +
      '<li>Pinch the spot where the end meets, or mark it with a pen.</li>' +
      '<li>Lay it flat along a ruler. No ruler? A sheet of printer paper is 11 in long, and a dollar bill is about 6 in.</li></ol></div></div>' : '';
    var tips = '<ul class="cz-how__tips">' +
      (tapeable ? '<li>Keep your ' + pet + ' standing and the string snug, with room for two fingers underneath.</li>' : '') +
      (/(larger|smaller|bigger) size|size up|between sizes|two sizes/i.test(tipText) ? '' : '<li>Between two sizes? Choose the larger one.</li>') + '</ul>';
    var wrap = document.createElement('div');
    wrap.className = 'cz-how';
    wrap.innerHTML = '<h3>How to Measure Your ' + pet.charAt(0).toUpperCase() + pet.slice(1) + '</h3>' +
      '<p class="cz-how__sub">It only takes a minute. Use the measurements below with the chart above.</p>' +
      '<div class="cz-how__grid">' + cards + '</div>' + tape + tips;
    return wrap;
  }

  function enhance(dialog) {
    var body = dialog.querySelector('.cz-sg-modal__body');
    var sg = body && body.querySelector('.cz-sg');
    if (!sg || body.querySelector('.cz-how')) return;
    ensureCss();
    var block = build(sg);
    if (!block) return;
    block.id = 'CzHowToMeasure';
    sg.parentNode.insertBefore(block, sg.nextSibling);
    var jump = document.createElement('a');
    jump.className = 'cz-how__jump';
    jump.href = '#CzHowToMeasure';
    jump.textContent = 'Not sure how to measure? See how ↓';
    jump.addEventListener('click', function (e) { e.preventDefault(); block.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    sg.parentNode.insertBefore(jump, sg);
  }

  function watch() {
    var d = document.getElementById('CzSgModal');
    if (d && !d.__czHow) {
      d.__czHow = true;
      new MutationObserver(function () { if (d.hasAttribute('open')) enhance(d); }).observe(d, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
      if (d.hasAttribute('open')) enhance(d);
    }
  }

  function init() {
    if (!document.querySelector('.cz-sg')) return;
    ensureCss();
    watch();
    new MutationObserver(watch).observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Size buttons always in shopper order (XS, S, M, L, XL, 2XL...), even when Shopify keeps
     a product's values in the supplier's order. Numeric sizes sort by number; anything else
     (e.g. "French Bulldog") stays at the end in its original order. */
  var RANK = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, '2XL': 6, XXXL: 7, '3XL': 7, '4XL': 8, '5XL': 9, '6XL': 10 };
  function rank(v, i) {
    var k = String(v || '').trim().toUpperCase();
    if (k in RANK) return RANK[k];
    if (/^\d+(\.\d+)?$/.test(k)) return parseFloat(k);
    return 1000 + i;
  }
  function sortSizes() {
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (inputs.length < 2 || !/size/i.test(inputs[0].name || '')) return;
      var pairs = inputs.map(function (inp, i) {
        var lbl = fs.querySelector('label[for="' + inp.id + '"]');
        return { inp: inp, lbl: lbl, r: rank(inp.value, i) };
      });
      var sorted = pairs.slice().sort(function (a, b) { return a.r - b.r; });
      if (sorted.every(function (p, i) { return p === pairs[i]; })) return;
      var anchor = document.createComment('cz');
      fs.insertBefore(anchor, pairs[0].inp);
      sorted.forEach(function (p) { fs.insertBefore(p.inp, anchor); if (p.lbl) fs.insertBefore(p.lbl, anchor); });
      anchor.remove();
    });
  }
  function initSizes() {
    if (!document.querySelector('variant-selects')) return;
    sortSizes();
    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(sortSizes).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSizes); else initSizes();
})();